module.exports = __webpack_public_path__ + "media/assets/images/bulloni_digitali/gigi-e455d9c90495e4bc7cd10c410d4bab0f.jpeg";